"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var focus_1 = require("./focus");
var FocusPositionObserver = /** @class */ (function () {
    function FocusPositionObserver(root) {
        var _this = this;
        this.observerConfig = {
            subtree: true,
            childList: true,
        };
        this.nodes = [];
        this.nodesCached = false;
        this.activeElement = null;
        this.observe = function (options) {
            _this.observer = new MutationObserver(function (records) {
                return _this.handleMutation(records, options);
            });
            _this.observer.observe(_this.root, _this.observerConfig);
            _this.sync();
        };
        this.handleMutation = function (records, options) {
            var _a;
            var hasRemovedRecords = records.find(function (record) { return record.removedNodes.length; });
            var prevNodes = _this.nodes;
            var nextNodes = (0, focus_1.getFocusableElements)(_this.root);
            /**
             * Enable the focus if the focus wasn't trapped before but got focusable elements added
             * e.g. popover was displaying a loading state and switched to the loaded state with links
             */
            if (!prevNodes.length && nextNodes.length) {
                (_a = options.onFocusEnable) === null || _a === void 0 ? void 0 : _a.call(options);
            }
            if (!hasRemovedRecords) {
                _this.nodesCached = false;
                _this.sync();
                return;
            }
            if (document.activeElement !== document.body)
                return;
            var prevActiveElementIndex = _this.activeElement
                ? prevNodes.indexOf(_this.activeElement)
                : -1;
            var lengthDiff = nextNodes.length - prevNodes.length;
            var nextElement = nextNodes[0];
            if (prevActiveElementIndex !== -1) {
                switch (true) {
                    case lengthDiff === 0:
                        nextElement = nextNodes[prevActiveElementIndex];
                        break;
                    case lengthDiff > 0:
                        nextElement = nextNodes[prevActiveElementIndex + lengthDiff];
                        break;
                    case lengthDiff < 0:
                        var average = Math.floor((prevNodes.length - nextNodes.length) / 2);
                        var start = Math.max(average, 1);
                        var resolvedIndex = start > 1 && start % 2 ? start - 1 : start + 1;
                        var existingIndex = Math.max(0, Math.min(nextNodes.length - 1, resolvedIndex));
                        nextElement = nextNodes[existingIndex];
                        break;
                    default:
                        break;
                }
            }
            if (nextElement)
                options.onFocusUpdate(nextElement);
            _this.nodesCached = false;
            _this.sync();
        };
        this.sync = function () {
            if (!_this.nodesCached) {
                _this.nodes = (0, focus_1.getFocusableElements)(_this.root);
                _this.nodesCached = true;
            }
            _this.activeElement = (0, focus_1.getActiveElement)();
        };
        this.disconnect = function () {
            var _a;
            _this.nodes = [];
            _this.activeElement = null;
            (_a = _this.observer) === null || _a === void 0 ? void 0 : _a.disconnect();
            _this.observer = undefined;
        };
        this.root = root;
    }
    return FocusPositionObserver;
}());
exports.default = FocusPositionObserver;
